import { useEffect } from 'react';
import { withVueRouter, connectVuex } from 'vuereact-combined';
const AuthenticatedApp = ({ $vueRouter, vuexCommit, data = {} }) => {
    const { sessionId, firstName, lastName, username, id, } = data;
    useEffect(() => {
        vuexCommit('student/setStudent', {
            sessionId,
            id,
            firstName,
            lastName,
            username,
            successfullyLoggedIn: true,
        }, { root: true });
        $vueRouter.push({ path: 'curriculum' }).catch(failure => {
            console.log({ failure });
            '';
        });
    }, []);
    return null;
};
export default connectVuex({
    mapCommitToProps(commit) {
        return {
            vuexCommit: commit
        };
    }
})(withVueRouter(AuthenticatedApp));
